<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View/ Edit Provider</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">
            Save
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input v-model="editForm.name" placeholder="Name">
            <template slot="prefix">Name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-select v-model="editForm.type" placeholder="Type">
            <el-option
              v-for="typeOption in typeOptions"
              :key="typeOption"
              :label="typeOption"
              :value="typeOption"
            />
            <template slot="prefix">Type</template>
          </el-select>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input
            v-model="editForm.digitsToAdd"
            placeholder="Digits To Add"
          >
            <template slot="prefix">Digits To Add</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-input
            v-model.number="editForm.digitsToDelete"
            type="number"
            placeholder="DigitsToDelete"
            @input="checkForPositiveNumber"
          >
            <template slot="prefix">DigitsToDelete</template>
          </el-input>
        </el-col>
      </div>
      <template v-if="type === 'IN'">
        <h2 class="form-section-header">Host IP addresses</h2>
        <el-input v-model="editForm.host" type="textarea" placeholder="Host">
        </el-input>
      </template>
      <div v-if="type === 'OUT'" class="inline-form-group">
        <el-col :span="12">
          <h2 class="form-section-header">Host IP address</h2>
          <el-input v-model="editForm.host" placeholder="IP Address">
            <template slot="prefix">Host IP addresses</template>
          </el-input>
        </el-col>
      </div>
      <h2 class="form-section-header">
        Custom headers
      </h2>
      <el-input v-model="editForm.sipHeader1" placeholder="SIP Header 1">
        <template slot="prefix">SIP Header 1</template>
      </el-input>
      <el-input v-model="editForm.sipHeader2" placeholder="SIP Header 2">
        <template slot="prefix">SIP Header 2</template>
      </el-input>
    </el-form>
  </el-dialog>
</template>

<script>
import { debounce } from "lodash";

export default {
  name: "ProvidersEditForm",

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    selectedProvider: { required: true }
  },

  data() {
    return {
      typeOptions: ["IN", "OUT"],
      editForm: {
        name: "",
        type: "",
        sipHeader1: "",
        sipHeader2: "",
        digitsToAdd: "",
        digitsToDelete: null,
        host: ""
      }
    };
  },

  computed: {
    type() {
      return this.editForm.type;
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedProvider(val) {
      if (val) {
        const {
          name,
          type,
          sipHeader1,
          sipHeader2,
          digitsToAdd,
          digitsToDelete,
          host
        } = val;
        this.editForm.name = name;
        this.editForm.type = type;
        this.editForm.sipHeader1 = sipHeader1;
        this.editForm.sipHeader2 = sipHeader2;
        this.editForm.digitsToAdd = digitsToAdd;
        this.editForm.digitsToDelete =
          digitsToDelete === 0 ? null : digitsToDelete;
        this.editForm.host = host;
      }
    }
  },

  methods: {
    checkForPositiveNumber(num) {
      debounce(() => {
        if (num < 0) {
          this.editForm.digitsToDelete = null;
        }
      }, 300)();
    },

    editOperation() {
      const editBody = { ...this.editForm };
      const { digitsToDelete } = editBody;

      editBody.digitsToDelete = digitsToDelete ? digitsToDelete : 0;
      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.editForm = {
        name: "",
        type: "",
        sipHeader1: "",
        sipHeader2: "",
        digitsToAdd: "",
        digitsToDelete: null,
        host: ""
      };
    }
  }
};
</script>
